import { useEffect } from "react";
import "./App.css";
import RouteList from "./Common/RouteList";


function App() {

  // useEffect(() => {
  //   loadGoogleMaps();
  // }, []);
  useEffect(() => {
    document.addEventListener("selectstart", (e) => e.preventDefault());
    return () => document.removeEventListener("selectstart", (e) => e.preventDefault());
  }, []);

  return (
    <>
      <RouteList />
    </>
  );
}

export default App;
